import { combineReducers } from 'redux';

import ready from './ready';

/**
 * @typedef {{
 *  ready: boolean,
 * }} VehicleCheckModelsUIDetailsReducer
 */

export default combineReducers({
  ready,
});
